import { NormalizedCacheObject } from 'apollo-boost';
import { ApolloQueryResult } from 'apollo-client';
import { ModifiableWatchQueryOptions } from 'apollo-client/core/watchQueryOptions';
import { DocumentNode } from 'graphql';

import { RUM, RumCountersDictKeys } from '../../service/RUM/RUM';
import { QueryAdditionalData } from '../../typings/common';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export abstract class BaseDataProvider {
    constructor(protected client: DNAApolloClient<NormalizedCacheObject>) {}

    protected createQuery<T extends QueryAdditionalData>(
        query: DocumentNode,
        options: ModifiableWatchQueryOptions = {},
        key?: RumCountersDictKeys
    ): Promise<ApolloQueryResult<T>> {
        const runQuery = () =>
            this.client
                .query<T>({
                    // отключаем кеширование запросов, так как при выполнении массовых действий над элементами таблицы
                    // нужна перезагрузка данных с сервера
                    fetchPolicy: 'no-cache',
                    query,
                    ...options
                })
                .then((result: ApolloQueryResult<T>) => ({
                    result,
                    reqId: result.data.reqId
                }));

        if (key) {
            return RUM.reportAsyncDelta(key, runQuery);
        }

        return runQuery().then(result => result.result);
    }
}
